// extracted by mini-css-extract-plugin
export default {"fullWidth":"ln-z","image":"mn-z","lazyLoadPicture":"nn-z","lazyLoadSpinner":"on-z","lazyLoadSpin":"pn-z","lazyLoadImage":"qn-z","hasStyledAspectRatio":"rn-z"};